import React from "react"
import Select from "react-select"
import { SiteOption } from "../../../types/SiteOption"

interface Props {
    sites: SiteOption[]
    value: SiteOption[]
    onChange: (sites: SiteOption[]) => void
    disabled?: boolean
}

export default function SiteMultiSelect({ sites, value, onChange, disabled }: Props) {
    return (
        <div className="mb-3" style={{ maxWidth: '500px' }}>
            <label className="text-muted mb-1">
                <small>Sites</small>
            </label>
            <Select
                multi
                options={sites}
                value={value}
                onChange={onChange}
                placeholder="Sélectionner un ou plusieurs sites..."
                noOptionsMessage={() => "Aucun site trouvé"}
                disabled={disabled}
            />
        </div>
    )
}
